<template>
    <div class="recharge-record-container">
      <!-- 顶部标题栏 -->
      <div class="page-header">
        <h1 class="page-title">探访工厂统计中心</h1>
      </div>
  
      <!-- 导航栏 -->
      <div class="nav-bar">
        <div class="nav-left">
          <span class="back-btn" @click="goBack">‹</span>
          <el-date-picker
            v-model="selectedMonth"
            type="month"
            placeholder="选择月份"
            format="yyyy-MM"
            value-format="yyyy-MM"
            @change="onMonthChange"
            class="month-picker"
          />
        </div>
        <div class="nav-right">
         
          <span class="balance-label">当前余额</span>
          <span class="balance-value">{{ currentBalance || '0.00' }}</span>
         
        </div>
      </div>
  
      <!-- 充值记录表格 -->
      <div class="record-section">
        <div class="record-card">
          <div class="record-title">充值记录</div>
          <div class="table-container">
            <table class="record-table">
              <thead>
                <tr>
                  <th>日期</th>
                  <th>充值金额</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in recordList" :key="index">
                  <td>{{ item.date }}</td>
                  <td>{{ item.amount }}</td>
                </tr>
                <tr v-if="!recordList || recordList.length === 0">
                  <td colspan="2" class="no-data">暂无充值记录</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
  
      
    </div>
  </template>
  
  <script>
  import common from '@/utils/common';
  
  export default {
    name: 'LiveRechargeRecord',
    data() {
      return {
        shopId: null,
        dealerMobile: '',
        selectedMonth: new Date().toISOString().slice(0, 7),
        currentBalance: '0.00',
        recordList: [],
        showRechargeModal: false,
        rechargeAmount: ''
      }
    },
    created() {
        this.loadData();
    },
    methods: {
      // 加载数据
      loadData() {
        const params = {
          
          month: this.selectedMonth
        };
        
        common.connect('/distributorpcv1/jiaofu/recharge_record', params, (res) => {
          
          this.currentBalance = res.data.current_balance || '0.00';
          this.recordList = res.data.records || [];
        });
      },
      
      // 月份变化
      onMonthChange() {
        this.loadData();
      },
      
      // 返回
      goBack() {
        this.$router.go(-1);
      },
      
      // 显示充值对话框
      showRechargeDialog() {
        this.showRechargeModal = true;
        this.rechargeAmount = '';
      },
      
      // 关闭充值对话框
      closeRechargeDialog() {
        this.showRechargeModal = false;
        this.rechargeAmount = '';
      },
      
      // 确认充值
      confirmRecharge() {
        if (!this.rechargeAmount || parseFloat(this.rechargeAmount) <= 0) {
          this.$message.warning('请输入有效的充值金额');
          return;
        }
        
        const params = {
          shop_id: this.shopId,
          amount: parseFloat(this.rechargeAmount)
        };
        
        common.connect('/enterprise/jiaofu/recharge', params, (res) => {
          this.$message.success('充值成功');
          this.closeRechargeDialog();
          this.loadData(); // 重新加载数据
        });
      }
    }
  }
  </script>
  
  <style scoped>
  .recharge-record-container {
    min-height: 100vh;
    background: #f0f0f0;
    color: #333;
    font-family: 'Microsoft YaHei', sans-serif;
    padding: 20px;
  }
  
  .page-header {
    margin-bottom: 20px;
  }
  
  .page-title {
    font-size: 22px;
    font-weight: 600;
    color: #333;
    margin: 0;
    border-left: 4px solid #3b82f6;
    padding-left: 10px;
  }
  
  /* 导航栏 */
  .nav-bar {
    background: #ffffff;
    padding: 15px 20px;
    border-radius: 8px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 15px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  
  .nav-left {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  .back-btn {
    font-size: 24px;
    color: #333;
    cursor: pointer;
    font-weight: bold;
    line-height: 1;
  }
  
  .back-btn:hover {
    color: #3b82f6;
  }
  
  .dealer-label {
    font-size: 14px;
    color: #666;
  }
  
  .dealer-id {
    font-size: 14px;
    color: #333;
    font-weight: 500;
  }
  
  .nav-right {
    display: flex;
    align-items: center;
    gap: 15px;
    flex-wrap: wrap;
  }
  
  .month-picker {
    width: 150px;
  }
  
  .balance-label {
    font-size: 14px;
    color: #666;
  }
  
  .balance-value {
    font-size: 16px;
    color: #333;
    font-weight: 500;
  }
  
  .recharge-btn-main {
    background: #3b82f6;
    color: #fff;
    border: none;
    padding: 8px 20px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.3s;
  }
  
  .recharge-btn-main:hover {
    background: #2563eb;
  }
  
  /* 充值记录区域 */
  .record-section {
    margin-top: 20px;
  }
  
  .record-card {
    background: #ffffff;
    border-radius: 12px;
    padding: 20px;
    border: 1px solid #e0e0e0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  
  .record-title {
    font-size: 18px;
    font-weight: 500;
    color: #333;
    margin-bottom: 20px;
  }
  
  .table-container {
    overflow-x: auto;
  }
  
  .record-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
  }
  
  .record-table thead {
    background: #f5f5f5;
  }
  
  .record-table th {
    padding: 12px 15px;
    text-align: left;
    color: #333;
    font-weight: 500;
    border-bottom: 1px solid #e0e0e0;
  }
  
  .record-table td {
    padding: 12px 15px;
    color: #333;
    border-bottom: 1px solid #f0f0f0;
  }
  
  .record-table tbody tr:hover {
    background: #f9f9f9;
  }
  
  .no-data {
    text-align: center;
    color: #999;
    padding: 30px !important;
  }
  
  /* 充值对话框 */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }
  
  .modal-content {
    background: #ffffff;
    border-radius: 12px;
    width: 400px;
    max-width: 90vw;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  }
  
  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid #e0e0e0;
  }
  
  .modal-header h3 {
    margin: 0;
    font-size: 18px;
    color: #333;
  }
  
  .close-btn {
    background: none;
    border: none;
    font-size: 24px;
    color: #999;
    cursor: pointer;
    padding: 0;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: all 0.3s;
  }
  
  .close-btn:hover {
    background: #f5f5f5;
    color: #333;
  }
  
  .modal-body {
    padding: 20px;
  }
  
  .form-group {
    margin-bottom: 20px;
  }
  
  .form-group label {
    display: block;
    color: #333;
    font-size: 14px;
    margin-bottom: 8px;
    font-weight: 500;
  }
  
  .form-input {
    width: 100%;
    padding: 10px 12px;
    background: #ffffff;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    color: #333;
    font-size: 14px;
    box-sizing: border-box;
    transition: all 0.3s;
  }
  
  .form-input:focus {
    outline: none;
    border-color: #3b82f6;
  }
  
  .modal-footer {
    padding: 20px;
    border-top: 1px solid #e0e0e0;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }
  
  .btn-cancel, .btn-confirm {
    padding: 8px 16px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s;
    border: none;
  }
  
  .btn-cancel {
    background: #f5f5f5;
    color: #333;
    border: 1px solid #e0e0e0;
  }
  
  .btn-cancel:hover {
    background: #e8e8e8;
  }
  
  .btn-confirm {
    background: #3b82f6;
    color: #fff;
  }
  
  .btn-confirm:hover:not(:disabled) {
    background: #2563eb;
  }
  
  .btn-confirm:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
  
  /* Element UI 日期选择器样式覆盖 */
  ::v-deep .el-date-editor.el-input {
    width: 150px;
  }
  
  ::v-deep .el-input__inner {
    background: #ffffff !important;
    border: 1px solid #e0e0e0 !important;
    color: #333 !important;
  }
  
  ::v-deep .el-input__inner::placeholder {
    color: #999 !important;
  }
  
  ::v-deep .el-input__icon {
    color: #666 !important;
  }
  
  /* 响应式设计 */
  @media (max-width: 768px) {
    .recharge-record-container {
      padding: 10px;
    }
    
    .nav-bar {
      flex-direction: column;
      align-items: flex-start;
    }
    
    .nav-right {
      width: 100%;
      justify-content: space-between;
    }
    
    .record-table {
      font-size: 12px;
    }
    
    .record-table th,
    .record-table td {
      padding: 8px 10px;
    }
  }
  </style>
  